import React from 'react';
import Dropzone from 'react-dropzone';
import UploadIcon from '@material-ui/icons/CloudUploadOutlined';
import { BsFillXCircleFill as RemoveIcon } from 'react-icons/bs';
import Request from 'superagent';

import { Progress } from 'components';
import { BASE_URL } from 'consts';

import '../styles/Media.css';

import { store } from 'store/createStore';

class Media extends React.Component {
  state = { loading: false };

  constructor(props) {
    super(props);

    this.uploadFile = this.uploadFile.bind(this);
    this.removeFile = this.removeFile.bind(this);
  }

  uploadFile(files) {
    this.setState({ loading: true });

    const { mediaFile, mediaTag } = this.props;
    const { token } = store.getState().auth;

    const request = Request.post(`${BASE_URL}/template/file`)
      .attach('file', files[0])
      .set('Authorization', token)
      .timeout(3600000);

    if (mediaFile) {
      request.field('id', mediaFile);
    }

    if (mediaTag) {
      request.field('tag', mediaTag);
    }

    request.end((err, res) => {
      if (!err && res.statusCode === 201) {
        const file = JSON.parse(res.text);
        this.props.onChange(file.id, file.url, file.contentType);
      }

      this.setState({ loading: false });
    });
  }

  removeFile() {
    this.setState({ loading: true });

    const { mediaFile } = this.props;
    const { token } = store.getState().auth;

    const request = Request.delete(`${BASE_URL}/template/file`)
      .field('id', mediaFile)
      .set('Authorization', token)
      .timeout(3600000);

    request.end((err, res) => {
      if (!err && res.statusCode === 202) {
        this.props.onChange(null, null);
      }

      this.setState({ loading: false });
    });
  }

  componentDidMount() {
    if (this.props.mediaFile) {
      const onFetch = url => {
        if (this.props.standalone) {
          this.props.onFetch(this.props.mediaFile, url);
        } else {
          this.props.onFetch(url);
        }
      };

      if (this.props.mediaUrl) {
        onFetch(this.props.mediaUrl);
      } else {
        Request.get(`${BASE_URL}/fileUrl/${this.props.mediaFile}`)
          .set('Authorization', store.getState().auth.token)
          .end((err, res) => {
            if (!err && res.text) {
              onFetch(res.text);
            }
          });
      }
    }
  }

  render() {
    if (this.state.loading) {
      return <Progress />;
    }

    const {
      size,
      mediaUrl,
      mediaType = 'image',
      maxSize,
      mediaFile,
      standalone,
      updateImageToSend,
    } = this.props;

    const dropzone = accept => (
      <Dropzone
        className="dropzone"
        accept={accept}
        onDrop={this.uploadFile}
        maxSize={maxSize ? maxSize : 10 * 1024 * 1024}
      >
        <UploadIcon className="icon" style={{ fontSize: size * 0.15 }} />

        {mediaFile ? (
          <div
            className="bt-remove"
            onClick={event => {
              event.stopPropagation();
              if (standalone) {
                updateImageToSend('', '');
              } else {
                this.removeFile();
              }
            }}
          >
            <RemoveIcon />
          </div>
        ) : null}
      </Dropzone>
    );

    if (mediaType === 'image') {
      return (
        <div
          className="image-container"
          style={{
            backgroundImage: `url(${mediaUrl})`,
            padding: `${size * 0.0618}px`,
          }}
        >
          {dropzone('image/jpeg, image/jpg, image/png, image/gif')}
        </div>
      );
    }

    return (
      <div className="video-container">
        {mediaUrl ? (
          <video autoPlay loop muted>
            <source src={mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : null}
        <div
          style={{
            padding: `${size * 0.0618}px`,
          }}
        >
          {dropzone('video/mp4')}
        </div>
      </div>
    );
  }
}

export default Media;
